import useSWR from 'swr'
import fetcher from './fetcher'

export default function useIncomeStatement(id, period) {
  const { data, error, isLoading } = useSWR(`/react/income_statements?stock_id=${id}&period=${period}`, (path) => fetcher(path, 'POST'))

  return {
    incomeStatement: data,
    isLoading,
    error
  }
}